import React from 'react';
import ReactDOM from 'react-dom';
import './semantic/dist/semantic.min.css';
import './index.css';
import registerServiceWorker from './registerServiceWorker';
import Home from "./pages/Home";
import { LocalizeProvider } from "react-localize-redux";
import { BrowserRouter as Router, Route } from "react-router-dom";

const App = () => (
  <LocalizeProvider>
    <Router>
      <Route exact path="/" component={Home}/>
    </Router>
  </LocalizeProvider>
);

ReactDOM.render(<App />, document.getElementById('root'));
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js